<script setup lang="ts">
import { ref } from 'vue';
import { useSenderStore } from '@/stores';
import WarningIcon from '../../icons/WarningIcon.vue';

defineProps({
  mainColor: {
    type: String,
    required: true,
  },
  backgroundColor: {
    type: String,
    required: true,
  },
});

const senderStore = useSenderStore();

const isSlowConnetionPopUpClosed = ref(false);
</script>

<template>
  <div
    v-if="senderStore.isSlowConnetion && !isSlowConnetionPopUpClosed"
    class="slow-connection-pop-up"
  >
    <WarningIcon class="slow-connection-pop-up-icon" :color="mainColor" />
    <p class="slow-connection-pop-up-text">
      Słabe połączenie. Przesyłanie plików może potrwać dłużej.
    </p>
    <button
      type="button"
      class="slow-connection-pop-up-close"
      @click="isSlowConnetionPopUpClosed = true"
    >
      X
    </button>
  </div>
</template>

<style lang="scss" scoped>
.slow-connection-pop-up {
  position: fixed;
  right: 10px;
  bottom: 25px;
  z-index: 10;
  color: v-bind(mainColor);
  border: 2px solid v-bind(mainColor);
  background-color: v-bind(backgroundColor);
  border-radius: 15px;
  padding: 10px 15px;
  padding-right: 50px;
  max-width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0 15px;

  @media screen and (max-width: $media-max-tablet) {
    flex-wrap: wrap;
    inset: 50% auto auto 50%;
    transform: translate(-50%, -50%);
    max-width: 50%;
    padding-right: 15px;
  }

  &-icon {
    height: 70px;
    width: 70px;
    min-width: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &-close {
    font-weight: 700;
    font-size: 20px;
    line-height: 14px;
    border: 2px solid v-bind(mainColor);
    padding: 10px;
    border-radius: 50%;
    cursor: pointer;
    position: absolute;
    top: 7px;
    right: 7px;
    transition: 1s ease all;

    @media screen and (max-width: $media-max-phone) {
      font-size: 17px;
      padding: 7px;
      line-height: 12px;
    }

    &:hover {
      color: v-bind(backgroundColor);
      background-color: v-bind(mainColor);
    }
  }

  &-text {
    font-weight: 700;
    font-size: 20px;
    text-align: center;

    @media screen and (max-width: $media-max-phone) {
      font-size: 15px;
    }
  }
}
</style>
